import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onMounted, ref, useSlots, watch } from 'vue';
import { BTableRow } from '@/typings/bootstrap/table';
import { BTable } from 'bootstrap-vue';
import { GenericPodVariant } from './typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantSelector',
  props: {
    value: { default: () => [] },
    variants: { default: () => [] },
    title: { default: 'Select one or more product variants' },
    showDoneButton: { type: Boolean, default: true },
    rowClassSetter: null
  },
  emits: ["input", "selection-finished", "details-visibility-change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: GenericPodVariant[]): void;
    (event: 'selection-finished', value: GenericPodVariant[]): void;
    (event: 'details-visibility-change', value: BTableRow): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: GenericPodVariant[], variants: GenericPodVariant[], title: string, showDoneButton: boolean, rowClassSetter?: (row: BTableRow) => string[] | null };





const slots = useSlots();

const thumbsProps = {
    width: 50,
    height: 50
};

const variantTableFields = [
    { key: 'name', label: '' },
    { key: 'price', label: '' }
];

const variantTableRef: Ref<BTable | null> = ref(null);

const hasDetailsView = computed((): boolean => {
    return !!slots['row-details'];
});

const selectedVariants = computed({
    get(): GenericPodVariant[] {
        return props.value;
    },
    set(value: GenericPodVariant[]) {
        emit('input', value);
    }
});

watch([selectedVariants, () => props.variants], () => {
    refreshSelectedRows();
});

onMounted(() => {
    refreshSelectedRows();
});

const getRowClasses = (row: BTableRow): { [key: string]: boolean } => {
    if (props.rowClassSetter) {
        const classes = props.rowClassSetter(row);
        if (classes) {
            const classesObject: { [key: string]: boolean } = {};
            for (const cssClass of classes) {
                classesObject[cssClass] = true;
            }
            return classesObject;
        }
    }
    return {};
};

const onRowSelected = (_selectedVariants: GenericPodVariant[]) => {
    selectedVariants.value = _selectedVariants;
};

const onDone = () => {
    emit('selection-finished', selectedVariants.value);
};

const onDetailsVisibilityChange = (row: BTableRow) => {
    row.detailsShowing = !row.detailsShowing;
    emit('details-visibility-change', row);
};

const refreshSelectedRows = () => {
    if (selectedVariants.value?.length && props.variants) {
        variantTableRef.value?.clearSelected();

        for (const variant of selectedVariants.value) {
            const index = props.variants.findIndex((v) => v.id === variant.id);
            if (index > -1) {
                variantTableRef.value?.selectRow(index);
            }
        }
    }
};

return { __sfc: true,props, emit, slots, thumbsProps, variantTableFields, variantTableRef, hasDetailsView, selectedVariants, getRowClasses, onRowSelected, onDone, onDetailsVisibilityChange, refreshSelectedRows, BTable }
}

})